import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertMessageComponent } from './alert-message.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [ AlertMessageComponent ],
    declarations: [ AlertMessageComponent ],
    entryComponents: [ AlertMessageComponent ],
})
export class AlertMessageModule {}
